<template>
  <div>
    <template v-if="loginError.errorMessage">
      <b-alert
        data-cy="alert-post-login-error"
        show
        variant="danger"
      >
        {{ loginError.errorMessage }}
      </b-alert>

      <div class="text-center mt-3">
        <BaseButtonLoader
          button-class="custom-button--wide custom-button--white-hover-grad pulse"
          type="button"
          @click="retryLogin"
        >
          Retry Login
        </BaseButtonLoader>
      </div>
    </template>

    <h5
      v-else
      class="text-center mt-3"
    >
      Logged in successfully, redirecting you to your dashboard
    </h5>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'LoginSuccess',

  computed: {
    ...mapState('auth', [
      'loginError'
    ])
  },

  methods: {
    ...mapActions('auth', [
      'retryLogin'
    ])
  }
}
</script>

<style>

</style>
